var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',{attrs:{"placement":"top","width":_vm.width,"trigger":"hover","content":_vm.content}},[_c('i',{staticClass:"el-icon-question",attrs:{"slot":"reference"},slot:"reference"})])
}
var staticRenderFns = []

export { render, staticRenderFns }